module.exports = __webpack_public_path__ + "img/affairs.f77d9c84.png";